export default {
  namespaced: true,
  state: () => ({
    task: {},
    maintainOrgs: '',
    maintainOrgList: [],
    taskNum: 0
  }),
  getters: {
    task: state => state.task,
    maintainOrgs: state => state.maintainOrgs,
    maintainOrgList: state => state.maintainOrgList,
    taskNum: state => state.taskNum
  },
  mutations: {
    setTask (state, task) {
      let maintainOrgs = state.maintainOrgs = task.maintainOrgs || ''
      state.maintainOrgList = maintainOrgs === '' ? [] : maintainOrgs.split('/')

      if (Array.isArray(task.taskDeviceList)) {
        task.taskDeviceList.forEach(taskDevice => {
          taskDevice.photoPath = taskDevice.photoPath || null
          taskDevice.fileStr = null
        })
      }

      state.task = task
    },
    setMaintainOrgs (state, maintainOrgs) {
      state.maintainOrgs = maintainOrgs
    },
    setTaskNum (state, taskNum) {
      state.taskNum = taskNum
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Task.js